import { render, staticRenderFns } from "./player-list.vue?vue&type=template&id=22266276&scoped=true&"
import script from "./player-list.vue?vue&type=script&lang=js&"
export * from "./player-list.vue?vue&type=script&lang=js&"
import style0 from "./player-list.vue?vue&type=style&index=0&id=22266276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22266276",
  null
  
)

export default component.exports